var _path, _circle, _circle2, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.01003 7.12911C5.93434 6.253 6.62509 5.5 7.50446 5.5H25.3327C26.333 5.5 27.053 6.46041 26.7726 7.42053L23.852 17.4205C23.6651 18.0603 23.0786 18.5 22.4121 18.5H8.36842C7.59004 18.5 6.94099 17.9046 6.87399 17.1291L6.01003 7.12911Z",
    stroke: "#21212C"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 23,
    r: 2.5,
    stroke: "#21212C"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 23,
    r: 2.5,
    stroke: "#21212C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6.5L5.66536 2.81893C5.57171 1.78877 4.70798 1 3.67357 1H0.5",
    stroke: "#21212C",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.a625679cb735c14b38f64a190c187832.svg";
export { ForwardRef as ReactComponent };